import { ReactNode, useCallback, useEffect, useRef, useState } from "react";
import InfoModal from "./InfoModal";
import { usePageContext } from 'vike-react/usePageContext';
import { GlobalEventEmitter, UserMessage } from "../../libs/eventLib";
import { Container, Navbar } from "react-bootstrap";

export default function InfoManager({ children }: { children: ReactNode }) {
	const {urlPathname} = usePageContext();
	const resolve = useRef<(value?: { clickedOK: boolean }) => void>();
	const [message, setMessage] = useState<UserMessage | undefined>(undefined);
	const [status, setStatus] = useState<ReactNode | undefined>(undefined);

	useEffect(() => {
		GlobalEventEmitter.on("info", setMessage);
		GlobalEventEmitter.on("status", setStatus);
		return () => {
			GlobalEventEmitter.off("info", setMessage);
            GlobalEventEmitter.off("status", setStatus);
		};
	}, []);

	const resetMessageState = useCallback(() => {
		setMessage(undefined);
	}, []);

	useEffect(() => {
		setMessage(undefined);
		setStatus(undefined);
	}, [urlPathname]);

	const handleCancel = useCallback(() => {
		if (message?.cancelCallback) message.cancelCallback();
		if (resolve.current) resolve.current({ clickedOK: false });
		resetMessageState();
	}, [message, resetMessageState]);

	const handleCallback = useCallback(() => {
		if (message?.callback) message.callback();
		if (resolve.current) resolve.current({ clickedOK: true });
		resetMessageState();
	}, [message, resetMessageState]);

	return (
		<>
			{message && <InfoModal message={message} cancelCallback={handleCancel} acceptCallback={handleCallback}></InfoModal>}
			{status && (
				<Navbar bg="primary" fixed="bottom">
					<Container>
						<p className="text-white">{status}</p>
					</Container>
				</Navbar>
			)}
			{children}
		</>
	);
}
